<template>
  <el-tooltip placement="top">
    <div slot="content">
      <!-- 現状は開発者が書いた固定文言のみだが、汎用コンポーネントのため必ずサニタイズを通す -->
      <div v-html="sanitizeHtml(htmlText)"></div>
      <div style="margin-top: 10px; text-align: center">
        <img
          :src="`${rt}/img/tools02/${imgPath}`"
          alt=""
        />
      </div>
    </div>
    <i class="el-icon-question"></i>
  </el-tooltip>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "OriginalToolTip",
  components: {
  },
  props: {
    htmlText: String,
    imgPath: String
  },
  data() {
    return {
      account: {},
    };
  },
  computed: {
    ...mapGetters(["rt", "tool", "apiErrorMessage"]),
  },
  watch: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
</style>
